import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { PageHeader } from "../components/TaskTable";
import { useData } from "../lib/DataContext";

export default function Departments() {
  const { departments } = useData();
  const [sel, setSel] = useState(null);
  const [dash, setDash] = useState(null);
  const nav = useNavigate();

  useEffect(() => {
    if (departments.length && !sel) setSel(departments[0].id);
  }, [departments, sel]);
  useEffect(() => {
    if (sel) api.get(`/departments/${sel}/dashboard`).then((r) => setDash(r.data));
  }, [sel]);

  const levelColor = { Low: "#16A34A", Normal: "#2563EB", High: "#CA8A04", Overloaded: "#DC2626" };

  return (
    <div className="p-6">
      <PageHeader title="Departments" subtitle="Department execution health & workload" />
      <div className="flex gap-2 mb-5 flex-wrap">
        {departments.map((d) => (
          <button key={d.id} data-testid={`dept-tab-${d.id}`} onClick={() => setSel(d.id)}
            className={`px-3 py-1.5 rounded-lg text-sm font-medium border ${sel === d.id ? "bg-slate-900 text-white border-slate-900" : "bg-white text-slate-600"}`}>
            {d.name}
          </button>
        ))}
      </div>
      {dash && (
        <>
          <div className="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-7 gap-3 mb-5">
            {[["total_open","Open"],["completed","Completed"],["due_today","Due Today"],["due_this_week","This Week"],["overdue","Overdue"],["blocked","Blocked"],["on_time_pct","On-Time %"]].map(([k,l]) => (
              <div key={k} className="bg-white border rounded-xl p-4">
                <div className="text-2xl font-bold font-mono text-slate-800">{dash.kpis[k]}{k === "on_time_pct" ? "%" : ""}</div>
                <div className="text-xs text-slate-500 mt-0.5">{l}</div>
              </div>
            ))}
          </div>
          <div className="bg-white border rounded-xl p-4">
            <div className="text-sm font-semibold text-slate-700 mb-3">Employee Workload</div>
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead><tr className="text-left border-b text-xs uppercase tracking-wide text-slate-400">
                  <th className="py-2">Employee</th><th className="py-2">Active</th><th className="py-2">Critical</th><th className="py-2">Overdue</th><th className="py-2">Capacity</th>
                </tr></thead>
                <tbody>
                  {dash.workload.map((w) => (
                    <tr key={w.id} className="border-b last:border-0">
                      <td className="py-2 font-medium text-slate-700">{w.name}</td>
                      <td className="py-2">{w.active}</td>
                      <td className="py-2 text-red-600">{w.critical}</td>
                      <td className="py-2 text-orange-600">{w.overdue}</td>
                      <td className="py-2"><span className="text-xs font-medium rounded-full px-2 py-0.5" style={{ backgroundColor: levelColor[w.level] + "20", color: levelColor[w.level] }}>{w.level}</span></td>
                    </tr>
                  ))}
                  {dash.workload.length === 0 && <tr><td colSpan={5} className="py-6 text-center text-slate-400">No active members</td></tr>}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
